import { useCallback, useState } from "react";
import Treeview from "@components/common/tree-view";
import {
  DataTreeViewItemValue,
  FlatNodeItem
} from "@components/common/tree-view/Interfaces";
import { getMaxSelected } from "@utils/Widget";
import { WidgetRuleProps } from "@components/widgets/base/setup/widget-rules/Interfaces";
import { useAnalyticsRuleData } from "@hooks/analytics/useAnalyticsRuleData";
import { TreeItem } from "@components/widgets/base/setup/widget-rules/sub/TreeItem";
import { HVLoader } from "@repo/HVComponents";
import { ObjectType } from "@queries/tanstack/analytics-filter/AnalyticsFilterQuery";
import { getRuleType } from "@hooks/analytics/useLocationRuleGroupByRuleType";
import { ANALYTICS_CHART_TYPE } from "@resources/Constants";
import * as S from "./AnalyticsRuleTree.styled";

export const MAX_LOCATION_COUNT = 20;
export const MAX_RULE_IN_ONE_LOCATION_COUNT = 20;

export const AnalyticsRuleTree = (
  props: WidgetRuleProps & { ruleCategory: ObjectType }
) => {
  const {
    onSelected,
    onChecked,
    rulesChecked = [],
    hoverItem,
    onHover
  } = props;
  const [expanded, setExpanded] = useState<DataTreeViewItemValue[]>([]);
  const aiType =
    props.analyticsChartType &&
    (getRuleType(
      props.analyticsChartType as keyof typeof ANALYTICS_CHART_TYPE
    ) as string);

  // use pre-fetched cache data from RuleButton.tsx
  const { data, isLoading } = useAnalyticsRuleData(
    {
      ruleCategory: props.ruleCategory,
      aiType
    },
    {
      refetchOnMount: false
    }
  );

  const onRenderItem = useCallback(
    (props: FlatNodeItem) => <TreeItem {...props} />,
    []
  );

  return (
    <S.Container>
      {isLoading || props.isForceRefreshing ? (
        <S.LoadingWrap>
          <HVLoader
            size={80}
            containerProps={{ h: "100%", justify: "center" }}
          />
        </S.LoadingWrap>
      ) : (
        <S.TreeWrap>
          <Treeview
            nodes={data}
            checked={rulesChecked}
            disabled={false}
            expanded={expanded}
            name="rule-tree-view"
            showIcon
            showCheckbox
            maxSelected={{
              ...getMaxSelected(),
              location: MAX_LOCATION_COUNT
            }}
            onClicked={onSelected}
            onChecked={onChecked}
            onExpanded={(expanded: FlatNodeItem[]) =>
              setExpanded(expanded.map((node) => node.value))
            }
            onRenderItem={(item) => onRenderItem(item)}
            hoverItem={hoverItem}
            onHover={onHover}
            useHoverTooltip
            isFirstAlwaysExpand
          />
        </S.TreeWrap>
      )}
    </S.Container>
  );
};
